/* eslint-disable no-unused-vars */
import { languages } from '../../lang'

import VueI18n from 'vue-i18n'
import Vue from 'vue'

const defaultLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'fr'
const messages = Object.assign(languages)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: defaultLanguage,
  messages,
})

export function $i18nMessages() {
  return i18n.messages[defaultLanguage]
}

export function $i18n(key) {
  return i18n.tc(key)
}
